import React from "react";

function Rockets() {
  return (
    <div className="h-12">
    <svg
  width="45.923" height="253.092" viewBox="10 1000 400 120 "
>
  <path
    d="M192.556,56.352c1.213,8-7.276,10.671-12.369,11.4l-.243-16.007V50.531C186.25,51.259,192.071,52.714,192.556,56.352Zm-18.432-6.063c0,.485-.242.97-.242,1.455L173.639,93.7l6.548-3.638-.243-22.07c4.608.243,11.4,1.213,11.4,4.851V90.063l6.306,3.638-.243-22.07c0-6.548-9.7-4.365-9.7-4.365s12.126-2.668,11.4-12.611c-.485-6.063-6.791-8.973-18.189-7.761h-1.7a41.129,41.129,0,0,0-2.425-8.973,50.4,50.4,0,0,0-2.668,9.944,64.956,64.956,0,0,0-11.884,3.153,109.093,109.093,0,0,1,11.884-.728Z"
    data-name="Path 3960"
    transform="translate(165.656 38.718)"
  />
  <path
    d="M203.229,76.186c0,3.88-2.183,6.306-5.821,6.306s-5.821-1.94-5.821-6.306V52.176c0-4.365,2.425-6.306,5.821-6.306a5.874,5.874,0,0,1,5.821,6.306Zm-1.7-33.226h-8s-8.488,0-8.488,8V77.4c0,8,8.488,8,8.488,8h8s8.488.243,8.488-8V50.963C210.02,42.96,201.532,42.96,201.532,42.96Z"
    data-name="Path 3961"
    transform="translate(188.936 43.864)"
  />
  <path
    d="M218.574,42.96h-8s-8.731,0-8.731,8V77.4c0,8,8.731,8,8.731,8h8s8.488.243,8.488-8V74h-6.548v2.183a5.8,5.8,0,0,1-6.063,6.306c-3.638,0-5.821-1.94-5.821-6.306V52.176c0-4.365,2.425-6.306,5.821-6.306a5.923,5.923,0,0,1,6.063,6.306v2.183h6.548v-3.4C227.305,42.96,218.574,42.96,218.574,42.96Z"
    data-name="Path 3962"
    transform="translate(206.089 43.864)"
  />
  <path
    d="M280.341,60.424c-5.578,0-7.276-.243-7.276-4.851V51.208c0-3.4.728-5.336,6.063-5.336,5.578,0,6.063,2.668,6.063,6.063v2.183l6.063-3.153v-.728a7.049,7.049,0,0,0-7.033-7.518h-9.459s-8,0-8,7.033v6.306c0,5.821.242,7.761,8.488,7.761,6.306,0,10.186.243,10.186,5.578v6.063c0,4.851-.728,7.033-6.063,7.033-5.578,0-6.306-2.668-6.306-7.761v-2.91L267,74.248v4.608c0,6.548,8,6.548,8,6.548h9.216a7.611,7.611,0,0,0,7.518-8.246V67.943C291.5,60.909,288.1,60.424,280.341,60.424Z"
    data-name="Path 3963"
    transform="translate(272.376 43.619)"
  />
  <path
    d="M242.353,75.842V65.656h2.183a49.977,49.977,0,0,0,15.279-2.91,53.474,53.474,0,0,0-15.279-2.91h-2.183V52.8c-.243-1.213.97-3.4,1.213-4.123a6.72,6.72,0,0,1,4.851-1.7h11.4c-.728-4.608-8.488-3.88-8.488-3.88h-6.791s-9.216,0-9.216,8.488V77.3c0,8.246,9.216,8,9.216,8h6.791s7.761.728,8.488-3.638h-11.4C248.174,81.42,242.353,81.905,242.353,75.842Z"
    data-name="Path 3964"
    transform="translate(240.274 43.966)"
  />
  <path
    d="M249.84,42.96v5.578h10.186V83.7l6.306,4.123V48.538h2.425a35.878,35.878,0,0,0,12.369-2.668,30.962,30.962,0,0,0-12.369-2.91Z"
    data-name="Path 3965"
    transform="translate(255.1 43.864)"
  />
  <path
    d="M244.468,45.165H238.4l-13.1,18.675V45.165L218.76,40.8V90.033l6.548-4.123V64.81l13.824,22.07h7.033L231.371,63.355Z"
    data-name="Path 3966"
    transform="translate(223.366 41.659)"
  />
  <path
    d="M35.475,76.186c0,3.88-2.183,6.306-5.821,6.306s-5.821-1.94-5.821-6.306V52.176c0-4.365,2.425-6.306,5.821-6.306a5.874,5.874,0,0,1,5.821,6.306ZM33.534,42.96h-8s-8.731,0-8.731,8V77.4c0,8,8.731,8,8.731,8h8s8.731.243,8.731-8V50.963C42.265,42.96,33.534,42.96,33.534,42.96Z"
    data-name="Path 3967"
    transform="translate(17.154 43.864)"
  />
  <path
    d="M51.907,46.84V76.429c0,6.063-4.851,6.063-4.851,6.063h-1.94a5.365,5.365,0,0,1-4.608-6.063V47.083L33.96,42.96V77.641c0,7.518,8,8,8,8h8.246s8.973-.243,8.973-8V61.877S58.94,43.2,58.94,42.96Z"
    data-name="Path 3968"
    transform="translate(34.675 43.864)"
  />
  <path
    d="M99,90.885l5.578-4.123V62.995l19.16,25.223V56.447a67.6,67.6,0,0,0-2.91-16.007,76.1,76.1,0,0,0-2.668,16.007V70.513L99,45.533Z"
    data-name="Path 3969"
    transform="translate(101.084 41.291)"
  />
  <path
    d="M63.861,60.424c-5.578,0-7.276-.243-7.276-4.851V51.208c0-3.4.728-5.336,6.063-5.336,5.578,0,6.063,2.668,6.063,6.063v2.183l6.063-3.153v-.728a7.049,7.049,0,0,0-7.033-7.518H58.283s-8,0-8,7.033v6.306c0,5.821.243,7.761,8.488,7.761,6.306,0,10.186.243,10.186,5.578v6.063c0,4.851-.728,7.033-5.821,7.033-5.821,0-6.548-2.668-6.548-7.761v-2.91l-6.063,2.425v4.608c0,6.548,7.761,6.548,7.761,6.548h9.459a7.611,7.611,0,0,0,7.518-8.246V67.943C75.26,60.909,71.622,60.424,63.861,60.424Z"
    data-name="Path 3970"
    transform="translate(51.339 43.619)"
  />
  <path
    d="M64.8,43.565V48.9H74.986V83.582L81.292,87.7V48.9h2.183A28.915,28.915,0,0,0,95.6,46.235a25.634,25.634,0,0,0-12.121-2.67Z"
    data-name="Path 3971"
    transform="translate(66.164 44.472)"
  />
  <path
    d="M88.631,76.309V52.3c0-4.365,2.425-6.306,5.821-6.306a5.923,5.923,0,0,1,6.063,6.306v24.01a5.8,5.8,0,0,1-6.063,6.306C90.813,82.614,88.631,80.917,88.631,76.309Zm9.7,9.216s8.731,0,8.731-8.246V51.086c0-8.246-8.731-8.246-8.731-8.246h-8s-8.488,0-8.488,8.246V77.279c0,8.246,8.488,8.246,8.488,8.246Z"
    data-name="Path 3972"
    transform="translate(83.563 43.742)"
  />
  <path
    d="M22.312,40.2a37.856,37.856,0,0,0-2.668,12.611v11.4H5.821v-11.4A43.5,43.5,0,0,0,2.91,40.2,48.923,48.923,0,0,0,.243,52.811L0,91.858l6.063-3.4V68.576H19.887V88.463l6.063,3.4-.243-39.047a65.191,65.191,0,0,0-3.4-12.611Z"
    data-name="Path 3973"
    transform="translate(0 41.046)"
  />
  <path
    d="M234.737,173.154l.242-31.043c28.618,3.638,52.143,7.518,52.143,14.552C287.365,164.18,265.78,170.243,234.737,173.154Zm-55.054,1.213.243-6.548c-.485-17.7.485-40.017.728-63.542,14.309,1.455,32.5,5.336,32.256,15.522l-.485,54.811c-5.336.243-10.671.243-16.007.243-5.821,0-11.4-.243-16.734-.485Zm-73.485-17.7c0-7.033,25.95-10.914,51.9-14.794,0,8.246-.243,17.462-.485,27.405v3.88C126.812,170.243,106.2,164.18,106.2,156.662ZM218,69.11c3.153,23.04-20.372,30.558-37.107,32.984a503.213,503.213,0,0,0-1.7-50.446C199.085,53.588,216.547,58.439,218,69.11Zm17.219,72.515.243-27.163c0-16.734-23.283-15.037-30.8-14.067,8.973-1.7,39.289-8.973,37.349-36.864C240.8,45.342,217.76,36.126,179.926,39.764c-.728,0-1.213.243-1.94.243A203.251,203.251,0,0,0,169.254.96a244.515,244.515,0,0,0-10.186,41.714,303.031,303.031,0,0,0-40.259,9.216A380.438,380.438,0,0,1,158.1,50.678c-2.425,24.253.242,47.05,0,90.947-40.017-1.213-74.941,6.548-74.456,18.189.485,10.429,31.286,19.887,74.456,23.525l1.94,58.934,2.91-40.017c.243-4.851,3.88-4.365,3.88-.243l1.213,52.386,3.4-42.685c0-5.821,3.88-5.336,3.638-.243l1.455,54.568,2.668-81.489c5.578.243,11.156.243,16.977.243,5.578,0,10.914,0,16.007-.243l2.668,83.187,2.183-43.655c0-5.578,3.88-5.336,3.88-.243l2.183,60.874,2.425-52.628c0-5.093,4.123-4.851,4.365,0l1.7,69.848,2.91-118.6C278.149,179.7,309.92,170,309.92,159.815c-.243-11.4-34.439-20.13-74.7-18.189Z"
    data-name="Path 3974"
    transform="translate(85.398 .98)"
  />
  <path
    fill="#ce1141"
    d="M193.4,55.632c.97,8-7.518,10.671-12.611,11.4V50.781a1.458,1.458,0,0,0-.243-.97C187.09,50.539,192.911,51.994,193.4,55.632Zm-18.675-6.063v1.213l-.485,42.2,6.548-3.638V67.273c4.365.243,11.4.97,11.156,4.608l.243,17.462,6.063,3.638V70.669c0-6.548-9.7-4.123-9.7-4.123s11.884-2.668,11.156-12.854c-.243-5.821-6.791-8.973-18.189-7.761-.485,0-1.213.243-1.455.243a31.577,31.577,0,0,0-2.668-8.973,46.29,46.29,0,0,0-2.668,9.944,83.263,83.263,0,0,0-11.641,2.91S168.658,49.569,174.721,49.569Z"
    data-name="Path 3975"
    transform="translate(166.514 37.983)"
  />
  <path
    fill="#ce1141"
    d="M204.315,75.589a5.8,5.8,0,0,1-6.063,6.306c-3.638,0-5.821-1.94-5.821-6.306V51.579c0-4.608,2.425-6.306,5.821-6.306a5.923,5.923,0,0,1,6.063,6.306Zm-1.94-33.469h-8s-8.731,0-8.731,8.246V76.559c0,8.246,8.731,8.246,8.731,8.246h8s8.488.243,8.488-8.246V50.366C210.863,42.12,202.374,42.12,202.374,42.12Z"
    data-name="Path 3976"
    transform="translate(189.548 43.007)"
  />
  <path
    fill="#ce1141"
    d="M219.172,42.12h-8s-8.488,0-8.488,8.246V76.559c0,8.246,8.731,8.246,8.731,8.246h8s8.488.243,8.488-8.246V73.406h-6.791v2.183c0,3.88-2.183,6.306-5.821,6.306s-5.821-1.94-5.821-6.306V51.579c0-4.608,2.425-6.306,5.821-6.306a5.873,5.873,0,0,1,5.821,6.306v2.183H227.9v-3.4C227.9,42.12,219.172,42.12,219.172,42.12Z"
    data-name="Path 3977"
    transform="translate(206.947 43.007)"
  />
  <path
    fill="#ce1141"
    d="M281.061,59.7c-5.578,0-7.276-.243-7.276-4.851V50.488c0-3.4.728-5.336,6.063-5.336,5.578,0,6.063,2.668,6.063,6.063V53.4l6.063-3.153v-.728A7.049,7.049,0,0,0,284.942,42h-9.458s-8,0-8,6.791v6.548c0,5.821.242,7.761,8.488,7.761,6.306,0,10.186.243,10.186,5.578v6.063c0,4.851-.728,7.033-5.821,7.033-5.821,0-6.548-2.668-6.548-7.761V71.1l-6.063,2.425v4.608c0,6.548,8,6.548,8,6.548h9.459s7.276,0,7.276-8.488V67.223C292.46,60.189,288.822,59.7,281.061,59.7Z"
    data-name="Path 3978"
    transform="translate(273.112 42.884)"
  />
  <path
    fill="#ce1141"
    d="M243.073,75.124V64.938h2.183a49.093,49.093,0,0,0,15.279-3.153,53.47,53.47,0,0,0-15.279-2.91h-2.183V52.084a7.668,7.668,0,0,1,1.455-4.123,7.2,7.2,0,0,1,4.851-1.94h11.4c-.97-4.365-8.488-3.638-8.488-3.638h-7.033s-9.216,0-9.216,8.488V76.337c0,8.488,9.216,8.246,9.216,8.246h7.033s7.518.728,8.488-3.88H249.136a5.34,5.34,0,0,1-6.063-5.578Z"
    data-name="Path 3979"
    transform="translate(241.01 43.229)"
  />
  <path
    fill="#ce1141"
    d="M250.56,42.24v5.578h10.186V82.984l6.548,4.123V47.818h2.425a34.26,34.26,0,0,0,12.126-2.91A29.834,29.834,0,0,0,269.72,42.24Z"
    data-name="Path 3980"
    transform="translate(255.835 43.129)"
  />
  <path
    fill="#ce1141"
    d="M245.188,44.445h-6.063l-13.1,18.675V44.2L219.48,40.08V89.313l6.548-4.123V63.848l13.824,22.07h7.033L232.091,62.392Z"
    data-name="Path 3981"
    transform="translate(224.101 40.924)"
  />
  <path
    fill="#ce1141"
    d="M36.315,75.589a5.8,5.8,0,0,1-6.063,6.306c-3.638,0-5.821-1.94-5.821-6.306V51.579c0-4.608,2.425-6.306,5.821-6.306a5.923,5.923,0,0,1,6.063,6.306ZM34.374,42.12h-8s-8.731,0-8.731,8.246V76.559c0,8.246,8.731,8.246,8.731,8.246h8s8.731.243,8.731-8.246V50.366C42.863,42.12,34.374,42.12,34.374,42.12Z"
    data-name="Path 3982"
    transform="translate(18.011 43.007)"
  />
  <path
    fill="#ce1141"
    d="M52.869,46.243V75.589c0,6.306-5.093,6.306-5.093,6.306h-1.94a6,6,0,0,1-4.851-6.306V62.25l.243-16.007L34.68,42.12V77.044c0,7.276,8,7.761,8,7.761h8.246s8.731-.243,8.731-7.761V42.12Z"
    data-name="Path 3983"
    transform="translate(35.41 43.007)"
  />
  <path
    fill="#ce1141"
    d="M99.84,90.046l5.578-4.123V62.155l19.16,25.223V55.607a67.6,67.6,0,0,0-2.91-16.007,76.919,76.919,0,0,0-2.91,16.007V69.673L99.84,44.693Z"
    data-name="Path 3984"
    transform="translate(101.942 40.434)"
  />
  <path
    fill="#ce1141"
    d="M64.581,59.7c-5.336,0-7.276-.243-7.276-4.851V50.489c0-3.4.728-5.336,6.063-5.336,5.578,0,6.306,2.668,6.306,6.063V53.4l6.063-3.153v-.728A7.2,7.2,0,0,0,68.462,42H59.246S51,42,51,48.791v6.548c0,5.821.485,7.761,8.488,7.761,6.548,0,10.186.243,10.186,5.578v6.063c0,4.851-.728,7.033-5.821,7.033-5.821,0-6.306-2.668-6.306-7.761V71.1l-6.063,2.425v4.608c0,6.548,7.761,6.548,7.761,6.548H68.7A7.7,7.7,0,0,0,76.223,76.2V67.223C75.98,60.19,72.585,59.7,64.581,59.7Z"
    data-name="Path 3985"
    transform="translate(52.074 42.884)"
  />
  <path
    fill="#ce1141"
    d="M65.64,42.72V48.3H75.826V82.737L81.889,87.1V48.3h2.425A30.79,30.79,0,0,0,96.441,45.63a29.753,29.753,0,0,0-12.126-2.91Z"
    data-name="Path 3986"
    transform="translate(67.022 43.619)"
  />
  <path
    fill="#ce1141"
    d="M89.351,75.589V51.579c0-4.608,2.425-6.306,5.821-6.306a5.923,5.923,0,0,1,6.063,6.306v24.01a5.8,5.8,0,0,1-6.063,6.306C91.533,81.894,89.351,79.954,89.351,75.589Zm9.944,8.973s8.488.243,8.488-8V50.366c0-8.246-8.488-8.246-8.488-8.246h-8s-8.731,0-8.731,8.246V76.559c0,8,8.731,8,8.731,8Z"
    data-name="Path 3987"
    transform="translate(84.298 43.007)"
  />
  <path
    fill="#ce1141"
    d="M23.152,39.36a47.063,47.063,0,0,0-2.91,12.854v11.4H6.418v-11.4A46.685,46.685,0,0,0,3.75,39.36,42.608,42.608,0,0,0,.84,52.214V91.261l6.063-3.4L6.661,67.978H20.727l-.243,19.887,6.063,3.4-.243-39.047A90.06,90.06,0,0,0,23.152,39.36Z"
    data-name="Path 3988"
    transform="translate(.858 40.189)"
  />
  <path
    fill="#ce1141"
    d="M235.7,172.194l.243-31.286c28.618,3.638,52.143,7.761,52.143,14.552C288.082,163.22,266.74,169.526,235.7,172.194Zm-22.312,1.455c-5.093,0-10.671.243-16.007.243-5.821,0-11.156-.243-16.734-.243l.243-6.791c-.485-17.462.485-39.774.728-63.542,14.309,1.7,32.5,5.336,32.256,15.522ZM180.158,50.688c19.645,1.94,37.349,6.548,38.8,17.462,2.91,23.04-20.372,30.558-37.349,32.984a502.657,502.657,0,0,0-1.455-50.446ZM158.573,172.194c-30.8-2.668-51.658-8.973-51.658-16.734,0-6.791,25.95-10.671,51.9-14.552,0,8.246-.243,17.462-.485,27.405Zm77.366-31.528.243-27.163c0-16.734-23.04-15.037-30.558-14.067,8.731-1.7,39.047-8.973,37.349-36.864C241.76,44.382,218.72,35.166,180.643,38.8c-.485,0-1.213.243-1.7.243A203.5,203.5,0,0,0,169.972,0a267.757,267.757,0,0,0-10.186,41.472,339.5,339.5,0,0,0-40.259,9.459,387.469,387.469,0,0,1,39.532-1.213c-2.425,24.253,0,47.05,0,90.947-40.017-1.213-74.941,6.306-74.456,18.189.243,10.429,31.286,19.887,74.456,23.525l1.7,58.934,3.153-40.017c0-4.851,3.638-4.608,3.638-.243L169,253.44l3.153-42.685c0-5.821,3.88-5.578,3.88-.243l1.455,54.568,2.668-81.489c5.578.243,11.156.243,16.977.243,5.336,0,10.914,0,16.007-.243l2.425,83.187,2.425-43.655c0-5.336,3.638-5.336,3.638-.243l2.425,60.874,2.183-52.628c.243-5.093,4.365-4.851,4.365,0l1.94,69.848,2.668-118.6v-.243c43.9-3.638,75.426-13.1,75.426-23.283C310.637,147.7,276.2,138.968,235.939,140.665Z"
    data-name="Path 3989"
    transform="translate(86.379)"
  />
</svg>;

    </div>
  );
}

export default Rockets;
